module.exports = __webpack_public_path__ + "img/win_6.2a097409.png";